export enum OrderDepartamentEnum {
  production = 'production',
  administration = 'administration',
  logistic = 'logistic',
}
